<template>
    <i id="copy-button" v-if="textToCopy && textToCopy.length > 0" class="far fa-copy" v-b-tooltip.hover :title="copyToPopupText" v-on:click="copyToClipboard()"></i>
</template>

<script>

export default {
  name: 'CopyToClipboard',
  props: [
    'textToCopy'
  ],
  data: () => {
      return {
          copyToPopupText: 'Copy to clipboard'
    }
  },
  methods: {
      copyToClipboard() {

          var tempInput = document.createElement("input");
          tempInput.type = "text"
          tempInput.value = this.textToCopy;
          document.getElementById(this.$el.id).appendChild(tempInput);
          tempInput.select();
          try {
              if (document.execCommand('copy')) {
                  this.copyToPopupText = 'Copied'
                  let self = this
                  setTimeout(function () {
                      self.copyToPopupText = 'Copy to clipboard'
                  }, 2000);
              }

          } catch (err) {
              console.log(err)
          }
          document.getElementById(this.$el.id).removeChild(tempInput)
      }
  }
}
</script>
